/**
 * Haptics (SPEC §8.1): Android uses navigator.vibrate(10). On iOS, only real taps can
 * produce haptics — the checkbox uses an `<input type=checkbox switch>` overlay for that.
 */
let enabled = true

export function setHapticsEnabled(on: boolean) {
  enabled = on
}

export function haptic(ms = 10) {
  if (!enabled) return
  try {
    navigator.vibrate?.(ms)
  } catch {
    /* ignore */
  }
}

export const isIOS =
  typeof navigator !== 'undefined' &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))

export const isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent)

export const isStandalone =
  typeof window !== 'undefined' &&
  (window.matchMedia?.('(display-mode: standalone)').matches || (navigator as Navigator & { standalone?: boolean }).standalone === true)

export const isTouch = typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0)

export const isMac = typeof navigator !== 'undefined' && /Mac/.test(navigator.platform)
